import { defineComponent as p, useAttrs as g, h as _, computed as s, openBlock as t, createBlock as x, resolveDynamicComponent as y, unref as a, normalizeClass as b, withCtx as C, createElementBlock as l, toDisplayString as o, createCommentVNode as r, createElementVNode as P, mergeProps as k } from "vue";
import { ProgressSizes as B, getProgressStyleClasses as A } from "./novoui-vuejs70.js";
const S = {
  key: 0,
  class: "progress-label"
}, T = {
  key: 1,
  class: "progress-percentage"
}, N = ["max", "value"], z = {
  key: 2,
  class: "progress-assistive-text"
}, w = /* @__PURE__ */ p({
  inheritAttrs: !1,
  __name: "NProgress",
  props: {
    value: { default: 0 },
    max: { default: 100 },
    label: { default: void 0 },
    hasPercentageIndicator: { type: Boolean, default: !1 },
    assistiveText: { default: void 0 },
    size: { default: B.medium },
    hasCompletedState: { type: Boolean, default: !0 },
    invalid: { type: Boolean }
  },
  setup(d) {
    const { class: n, ...m } = g(), v = p({
      render() {
        return _(() => this.$slots.default());
      }
    }), e = d, c = s(() => e.assistiveText && e.assistiveText.trim()), i = s(() => e.label && e.label.trim()), u = s(() => c.value || i.value || e.hasPercentageIndicator), h = s(() => A(e)), f = s(() => Math.floor(e.value / e.max * 100));
    return (I, D) => (t(), x(y(u.value ? "label" : a(v)), {
      class: b(["progress-container", a(n)])
    }, {
      default: C(() => [
        i.value ? (t(), l("span", S, o(e.label), 1)) : r("", !0),
        e.hasPercentageIndicator ? (t(), l("span", T, o(f.value) + "%", 1)) : r("", !0),
        P("progress", k({
          class: [h.value, u.value ? null : a(n)],
          max: e.max
        }, m, {
          value: e.value
        }), null, 16, N),
        c.value ? (t(), l("span", z, o(e.assistiveText), 1)) : r("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
export {
  w as default
};
